import style from './CarouselListItem.css';

export default function CarouselListItem({ className = '', item, onClick }) {
  return (
    <div className={`${className} ${style['container']}`} onClick={onClick}>
      <img className={style.image} src={item.image} />
      <div className={style.titlesContainer}>
        <p className={style.title}>{item.title}</p>
        <p className={style.body}>{item.body}</p>
      </div>
    </div>
  );
}
